import { render } from "./PokemonOptions.vue?vue&type=template&id=919dbb76"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=919dbb76&scope=true&lang=css"

import exportComponent from "C:\\PRACTICA\\04pokemon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__